
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
// import { objAny } from "../../common/common-interface";
@Component
export default class PiMaxNumber extends Vue {
  @Prop({ default: 0 }) private num!: number;
  @Prop({ default: 1000 }) private time!: number;
  @Watch("num")
  getVisible() {
    this.changeNumber();
  }

  private numData = 0;
  private setTime = 20;
  private speed = 0;
  private timer = 0;

  public changeNumber(): void {
    if (this.num > 99) {
      this.speed = (this.num / this.time) * this.setTime;
      clearTimeout(this.timer);
      this.numData = 0;
      this.timerChange();
    } else {
      clearTimeout(this.timer);
      this.numData = this.num + 0;
    }
  }
  public timerChange() {
    this.timer = setTimeout(() => {
      if (this.numData >= this.num) {
        this.numData = this.num + 0;
      } else {
        this.numData = Math.floor(this.numData + this.speed);
        this.timerChange();
      }
    }, this.setTime);
  }

  mounted() {
    this.$nextTick(() => {
      this.changeNumber();
    });
  }
}
